import React from "react";
import StyledDesktopMenu from "./DesktopMenu.styled";
import HR from "../../atoms/HR/HR.styled";
import Logo from "../../atoms/Logo";
import MenuItem from "../MenuItem";
import { IDesktopMenu } from "./DesktopMenu.interface";
import { H3 } from "../../atoms/H/H.styled";

const DesktopMenu = ({ list, adminList, ...props }: IDesktopMenu) => (
  <StyledDesktopMenu {...props}>
    <Logo onClick={props.logoClickHandler} />
    {props.subtitle && <H3>{props.subtitle}</H3>}
    <div>
      {list.map((item) => (
        <MenuItem
          key={item.text}
          Icon={item.Icon}
          label={item.text}
          to={item.link}
        />
      ))}
    </div>
    {adminList && adminList.length ? (
      <>
        <HR />
        <div>
          {adminList.map((item) => (
            <MenuItem
              key={item.text}
              Icon={item.Icon}
              label={item.text}
              to={item.link}
            />
          ))}
        </div>
      </>
    ) : null}
  </StyledDesktopMenu>
);

export default DesktopMenu;
